import { render } from "./pickets-13.vue?vue&type=template&id=182a16a2&scoped=true"
import script from "./pickets-13.vue?vue&type=script&lang=js"
export * from "./pickets-13.vue?vue&type=script&lang=js"

import "./pickets-13.vue?vue&type=style&index=0&id=182a16a2&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182a16a2"]])

export default __exports__